module.exports = require("@wildboar/x500/src/lib/comparators/compareBitStrings");